import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { fontFamily } from '@atlaskit/theme/constants';
import { defaultAttributesFn } from '../utils';
export var labelCSS = function labelCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      tokens = _ref.tokens;
  return _objectSpread({
    fontFamily: fontFamily(),
    alignItems: 'flex-start',
    display: 'flex',
    color: isDisabled ? tokens.label.textColor.disabled : tokens.label.textColor.rest
  }, isDisabled && {
    cursor: 'not-allowed'
  });
};
export function Label(_ref2) {
  var attributesFn = _ref2.attributesFn,
      children = _ref2.children,
      isDisabled = _ref2.isDisabled,
      onMouseUp = _ref2.onMouseUp,
      onMouseDown = _ref2.onMouseDown,
      onMouseLeave = _ref2.onMouseLeave,
      onMouseEnter = _ref2.onMouseEnter,
      tokens = _ref2.tokens,
      cssFn = _ref2.cssFn,
      testId = _ref2.testId;
  return jsx("label", _extends({}, attributesFn({
    isDisabled: isDisabled
  }), {
    onMouseUp: onMouseUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseEnter: onMouseEnter,
    css: cssFn({
      isDisabled: isDisabled,
      tokens: tokens
    }),
    "data-testid": testId
  }), children);
}
export default {
  component: Label,
  cssFn: labelCSS,
  attributesFn: defaultAttributesFn
};